import * as THREE from 'three';

export function Line(
    scene: THREE.Scene,
    x1: number,
    z1: number,
    x2: number,
    z2: number,
    thickness: number = 0.1
): void {
    const length: number = Math.sqrt((x2 - x1) ** 2 + (z2 - z1) ** 2);

    // Rectangle
    const lineGeometry = new THREE.PlaneGeometry(length, thickness); // Longueur x Épaisseur
    const lineMaterial = new THREE.MeshBasicMaterial({ color: 0xCFC4F7, side: THREE.DoubleSide });

    const line = new THREE.Mesh(lineGeometry, lineMaterial);

    // Centre en x1:z1 et x2:y2
    line.position.set((x1 + x2) / 2, -0.001, (z1 + z2) / 2);

    const angle: number = Math.atan2(z2 - z1, x2 - x1);
    line.rotation.set(-Math.PI / 2, 0, angle); // Rotation rester sur plan XZ

    scene.add(line);
}
